import { Company } from '../../../types/company/Company'

export interface ProductGroupQueryParams {
  companyId?: Company['id']
}

const productGroupQueryKeys = {
  all: [{ scope: 'productGroup' }] as const,
  lists: () => [{ ...productGroupQueryKeys.all[0], entity: 'list' }] as const,
  list: (params: ProductGroupQueryParams) => [{ ...productGroupQueryKeys.lists()[0], ...params }] as const
}

export default productGroupQueryKeys
